import { css } from 'aphrodite';
import React, { useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { commonStyles } from '../../Common/styling';
import { MenuTableCell, TableHead, TableRow } from '../../Common/Table';
import { EmployeeAgreementInterface } from './types';
import { useNotify } from '../../Common/snackbarHooks';
import { downloadPreviewEmployeeAgreement, getEmployeeAgreements } from './EmployeeAgreementAPI';
import { Grid, MenuItem, Table, TableBody, TableCell } from '@mui/material';
import { sort_order, ListParams } from '../../Common/types';
import { downloadFile, isEmpty } from '../../Common/utilities';
import EmptyList from '../../Common/Table/EmptyList';
import { QuickAction } from '../../Common/ButtonLinks';
import { FileDownloadOutlined } from '@mui/icons-material';

export const filterSortDefaults = {
  query: '',
  sort_by: 'ranking',
  sort_order: sort_order.asc,
  is_active: true,
};

const EmployeeAgreement: React.FC = () => {
  const rows = [
    { id: 'type_of', label: 'Typ', notSortable: true },
    { id: 'quick_action', label: '', notSortable: true },
  ];
  const navigate = useNavigate();
  const [listParams, setGetListParams] = useState(filterSortDefaults as ListParams);
  const [employeeAgreements, setEmployeeAgreements] = useState<Array<EmployeeAgreementInterface>>([]);
  const { notifyError } = useNotify();
  const [loadingPdf, setLoadingPdf] = useState(false);

  useEffect(() => {
    const fetchEmployeeAgreements = (): void => {
      getEmployeeAgreements()
        .then((data) => {
          setEmployeeAgreements(data.data.employee_agreement_templates);
        })
        .catch(() => notifyError('Det gick inte att hämta listan över avtalsmall'));
    };
    fetchEmployeeAgreements();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const downloadPreviewPdf = useCallback(
    (id: string, typeOf: string) => {
      if (loadingPdf) return;

      setLoadingPdf(true);
      downloadPreviewEmployeeAgreement(id)
        .then(({ data }) => {
          const blob = new Blob([data], { type: 'application/pdf' });
          downloadFile(blob, `avtalsmall-${typeOf.toLowerCase()}.pdf`);
        })
        .finally(() => {
          setLoadingPdf(false);
        });
    },
    [loadingPdf]
  );

  return (
    <div>
      <Grid container className={css(commonStyles.headlineWrapper, commonStyles.greyRow)}>
        <Grid item xs={10} sm={10} md={10} lg={10}>
          <h1 className={css(commonStyles.headerTextStyle)}>Avtalsmall</h1>
        </Grid>
      </Grid>

      <Table classes={{ root: css(commonStyles.tableWrapper) }}>
        <TableHead rows={rows} listParams={listParams} setGetListParams={setGetListParams} />
        <TableBody>
          {isEmpty(employeeAgreements) ? (
            <EmptyList />
          ) : (
            employeeAgreements.map((row: EmployeeAgreementInterface, idx: number) => (
              <TableRow row={row} idx={idx} key={idx} onClick={(): void => navigate(`${row.id}`)}>
                <TableCell scope="row">
                  <b>{row.type_of}</b>
                </TableCell>
                {['Deltagare', 'Teamledare'].includes(row.type_of) ? (
                  <MenuTableCell>
                    <MenuItem>
                      <QuickAction
                        onClick={(): void => {
                          downloadPreviewPdf(`${row.id}`, row.type_of);
                        }}
                        text="Ladda ned som pdf"
                        icon={<FileDownloadOutlined style={{ marginRight: '10px' }} />}
                        label="download_preview"
                        styles={commonStyles.selectionFabStyle3}
                      />
                    </MenuItem>
                  </MenuTableCell>
                ) : (
                  <TableCell scope="row"></TableCell>
                )}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default EmployeeAgreement;
